// Static data for the patient onboarding form + dashboard.

export const COUNTRIES = [
    { code: "IN", dial: "+91", name: "India" },
    { code: "US", dial: "+1", name: "United States" },
    { code: "GB", dial: "+44", name: "United Kingdom" },
    { code: "CA", dial: "+1", name: "Canada" },
    { code: "AU", dial: "+61", name: "Australia" },
    { code: "AE", dial: "+971", name: "UAE" },
    { code: "SG", dial: "+65", name: "Singapore" },
    { code: "DE", dial: "+49", name: "Germany" },
    { code: "FR", dial: "+33", name: "France" },
    { code: "JP", dial: "+81", name: "Japan" },
    { code: "NP", dial: "+977", name: "Nepal" },
    { code: "LK", dial: "+94", name: "Sri Lanka" },
    { code: "BD", dial: "+880", name: "Bangladesh" },
];

export const CITIES = [
    "Bengaluru",
    "Mumbai",
    "Delhi NCR",
    "Pune",
    "Hyderabad",
    "Chennai",
    "Kolkata",
    "Ahmedabad",
    "Jaipur",
    "Kochi",
    "Chandigarh",
    "Lucknow",
    "Indore",
    "Bhopal",
    "Surat",
    "Nagpur",
    "Coimbatore",
    "Thiruvananthapuram",
    "Guwahati",
    "Patna",
    "Visakhapatnam",
    "Vadodara",
    "Nashik",
    "Rajkot",
    "Bhubaneswar",
    "Other",
];

export const BLOOD_GROUPS = [
    "A+",
    "A-",
    "B+",
    "B-",
    "AB+",
    "AB-",
    "O+",
    "O-",
    "Unknown",
];

export const OCCUPATIONS = [
    "Corporate",
    "MNC",
    "Business Owner",
    "House Maker",
    "Student",
    "Retired",
    "Other",
];

export const GENDERS = [
    { key: "female", label: "Female" },
    { key: "male", label: "Male" },
    { key: "other", label: "Other" },
    { key: "prefer_not_to_say", label: "Prefer not to say" },
];

export const ILLNESSES = [
    "Diabetes",
    "Hypertension (High BP)",
    "Thyroid",
    "PCOS / PCOD",
    "Digestion issues",
    "Acidity / GERD",
    "Constipation",
    "Bloating / IBS",
    "Insomnia / Poor sleep",
    "Anxiety",
    "Depression",
    "Stress",
    "Migraine",
    "Joint pain / Arthritis",
    "Back pain",
    "Obesity / Weight gain",
    "Underweight",
    "Skin issues (acne / eczema)",
    "Hair fall",
    "Low immunity / Frequent illness",
    "Asthma",
    "Sinusitis",
    "Fatigue",
    "Menstrual issues",
    "Cholesterol",
    "Fatty liver",
    "None of the above",
];

// A small map from illness → dosha likely-affinity (used for filtering).
// (Simplified — the AI Guide gives the real personalised answer.)
export const ILLNESS_TO_TAG = {
    Stress: "vata",
    Anxiety: "vata",
    "Insomnia / Poor sleep": "vata",
    Migraine: "pitta",
    "Acidity / GERD": "pitta",
    "Skin issues (acne / eczema)": "pitta",
    "Obesity / Weight gain": "kapha",
    "Fatty liver": "kapha",
    "Low immunity / Frequent illness": "kapha",
};
